import React from 'react'
import LinkButton from "../button/LinkButton"

interface DeselectProps {
  onChange: (filters: string[]) => void
  selectedItems: string[]
}

const Deselect = ({ onChange, selectedItems }: DeselectProps) => (
  <LinkButton
    onClick={() => onChange([])}
    style={{
      fontSize: "0.8em",
      marginTop: 10,
      visibility: selectedItems.length > 0 ? "visible" : "hidden",
    }}
  >
    Deselect
  </LinkButton>
)

export default Deselect
